module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c0jCy"))).then(() => parcelRequire('d0iPb'));